module.exports = __webpack_public_path__ + "static/img/6.f3d2f77e.png";